<template>
  <div class="sk-top-shadow-wrap dynamic-content">
    <div class="block-01">
      <div class="title">新闻中心</div>
      <div class="list">
        <div v-for="(item, index) in newsList" :key="index">
          <div class="list-item" @click="jumpDetail(item.infoNo)">
            <div class="item-lf">
              <h4 class="name">{{ item.title }}</h4>
              <span class="date">{{ item.createTime }}</span>
              <p class="con">{{ item.content }}</p>
            </div>
            <div class="item-ri">
              <img :src="item.coverUrl" alt="">
            </div>
          </div>
        </div>
      </div>
      <a-pagination v-model="pageNum" :default-page-size="pageSize" :total="total" :show-total="total => `共${total}条`" show-less-items show-quick-jumper @change="onChange" />
    </div>
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import { getOfficialWebsiteInfomationList } from '@/apis/index'
export default {
  metaInfo: metaInfo.Dynamic,
  name: 'Dynamic',
  data() {
    return {
      newsList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getDynamicList()
  },
  methods: {
    jumpDetail(id) {
      this.$router.push({ path: '/dynamicDetail/' + id })
    },
    getDynamicList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getOfficialWebsiteInfomationList(params).then(res => {
        const { rows } = res
        rows.forEach(item => {
          item.content = item.content.replace(/<[^<>]+>/g, '')
        })
        this.newsList = res.rows
        this.total = res.total
      }).catch(err => {
        this.$message.error(err)
      })
    },
    onChange(page) {
      this.pageNum = page
      this.getDynamicList()
    }
  }
}
</script>
<style lang="less" scoped>
.dynamic-content {
  text-align: left;
  .block-01 {
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    color: #222;
    font-size: 30px;
    font-weight: 500;
  }
  .list {
    margin-top: 30px;
    &-item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0 30px;
      border-bottom: 1px solid #F2F2F2;
      margin-bottom: 40px;
      &:hover, &:focus {
        cursor: pointer;
      }
      .item-lf {
        width: 650px;
      }
      .item-ri {
        img {
          width: 488px;
          height: 288px;
        }
      }
      .name {
        font-size: 30px;
        color: #222;
        font-weight: 500;
        line-height: 42px;
      }
      .date {
        color: #8B8FA1;
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        margin-bottom: 15px;
        display: inline-block;
      }
      .con {
        color: #595961;
        font-size: 16px;
        line-height: 26px;
        font-weight: 400;
        display:-webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  /deep/ .ant-pagination {
    text-align: right;
    .ant-pagination-total-text {
      color: #222;
      font-size: 16px;
      font-weight: 400;
      margin-right: 33px;
    }
    .ant-pagination-options-quick-jumper input {
      text-align: center;
    }
    .ant-pagination-prev, .ant-pagination-next, .ant-pagination-jump-prev, .ant-pagination-jump-next {
      min-width: 34px;
      height: 34px;
      border-radius: 5px;
      margin-right: 10px;
      background: #FAFAFA;
      .ant-pagination-item-link {
        color: #A4A8B5;
      }
      &:focus, &:hover {
        .ant-pagination-item-link {
          color: #A4A8B5;
        }
      }
    }
    &-item-link {
      border: none;
    }
    &-item {
      min-width: 34px;
      height: 34px;
      border-radius: 5px;
      border: none;
      background: #FAFAFA;
      a {
        font-size: 16px;
        font-weight: 600;
        padding: 0;
        line-height: 34px;
        color: #333;
      }
      &:focus, &:hover {
        color: transparent;
      }
    }
    &-item-active {
      background: #3986FF;
      a {
        color: #fff;
      }
    }
  }
}
</style>
